/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FileDownloadHelper } from '../../store/FileDownloadHelper';
import { MisDatosService } from '../../services';
import useAPIError from '../../hooks/useAPIError';
import IconBack from '../../Icons/IconBack';

interface Props {
  title: string;
  textHTMLContent: string;
  textCentered: boolean;
  acceptButtonTextKey: string;
  cancelButtonTextKey?: string;
  showModal: boolean;
  isBig: boolean;
  isOro?: boolean;
  isSmall: boolean;
  setShowModal: (visible: boolean) => void;
  doAceptar: () => void;
  doClose: () => void;
  showCancel: boolean;
}

const ModalBajaSocioConsumidor: FC<Props> = (props) => {
  const { t } = useTranslation();
  const {
    doAceptar,
    doClose,
    title,
    textHTMLContent,
    textCentered,
    showModal,
    setShowModal,
    isBig,
    isSmall,
    showCancel,
    acceptButtonTextKey,
  } = props;

  const { addError } = useAPIError();

  const hideModal = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setShowModal(false);
  };

  const doDownLoad = () => {
    MisDatosService.bajaFormDownload()
      .then((response) => {
        if (response.data.error === true) {
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        } else {
          const fileName = t('datos.baja.bajaFileName');
          FileDownloadHelper.downloadFile(response, fileName);
        }
      })
      .catch((e) => {
        console.log(e);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
    setShowModal(false);
  };

  //* *** Save with Enter key
  const saveInfo = (e) => {
    if (e.key === 'Enter' && e.keyCode === 13) {
      doDownLoad();
    }
  };

  useEffect(() => {
    const element = document.getElementById(
      'modal-confirmacion',
    ) as HTMLElement;

    if (showModal) {
      element.setAttribute('tabindex', '0');
      element.focus();
      element.addEventListener('keydown', saveInfo, false);
    } else {
      element.removeEventListener('keydown', saveInfo, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  return (
    <div
      className={`modal ${
        isBig ? 'modal--large' : isSmall ? 'modal--small' : 'modal'
      } ${showModal ? 'is-active' : ''}`}
      id="modal-confirmacion"
    >
      <div className="modal__background" />
      <div className="modal__card u-text-center">
        <header className="modal__card-head u-flex">
          <div className="modal__card-title">{title}</div>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <a
            className="modal__card-close modal-cerrar"
            onClick={(e: any) => {
              hideModal(e);
              doClose();
            }}
          >
            <span className="hidden">Icono para cerrar modal</span>
            <div className="icon icon-medium icon--close">
              <IconBack />
            </div>
          </a>
        </header>
        <div className="modal__card-body">
          <fieldset>
            <div className="form-group select-wrapper u-margin-bottom">
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label className="control-label u-text-left u-full-width u-margin-bottom">
                <p
                  className={textCentered ? 'u-text-center' : ''}
                  dangerouslySetInnerHTML={{
                    __html: textHTMLContent,
                  }}
                />
              </label>
              <div className="modal__botonera">
                {(() => {
                  if (showCancel) {
                    return (
                      <>
                        <button
                          id="download-form-btn"
                          type="submit"
                          onClick={() => {
                            doDownLoad();
                          }}
                          className="btn btn-secundary u-margin-bottom-small"
                        >
                          {t('datos.baja.download-form')}
                        </button>
                      </>
                    );
                  }
                  return false;
                })()}
                <button
                  id="accept-btn"
                  type="submit"
                  onClick={(e: any) => {
                    hideModal(e);
                    doAceptar();
                  }}
                  className="btn btn-primary"
                >
                  {t(acceptButtonTextKey)}
                </button>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
};

export default ModalBajaSocioConsumidor;
